import {Button} from "@mui/material";
import React from "react";
import CarCog from "mdi-material-ui/CarCog";
import {useTranslation} from "../../Utils/CustomHooks/useTranslation";

interface IDamageButton {
    onClick: () => void;
    disabled: boolean;
}

const DamageButton: React.FunctionComponent<IDamageButton> = ({
                                                                  onClick,
                                                                  disabled

                                                              }): JSX.Element => {

    const {t} = useTranslation();


    return (
        <span>
                <Button
                    form="my-form"
                    name={"damageButton"}
                    size={"small"}
                    color={"secondary"}
                    onClick={onClick}
                    startIcon={
                        <CarCog data-testid={"damage-button-carCog-icon"}/>
                    }
                    data-testid={"damageButton"}
                    disabled={
                        disabled
                    }
                >
                    {t("general.damages")}
                </Button>
            </span>
    )
}

export default DamageButton;